import React from 'react';
import { Empty, Space, Table, Tag } from 'antd';
import moment from 'moment-timezone';
moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
const columns = [
  {
    title: 'Open Time',
    dataIndex: 'opening_date',
    key: 'opening_date',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => <a>{moment.utc(value).format("h:mm:ss A")}</a>,
    
    
  },
  {
    title: 'Symbol',
    dataIndex: 'symbol',
    key: 'symbol',
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    
  },
  // {
  //   title: 'ISIN',
  //   dataIndex: 'isin',
  //   key: 'isin',
  //   onCell: () => ({
  //     style: {
  //       whiteSpace: 'nowrap',
  //     },
  //   }),
  // },
  {
    title: 'Trade Date',
    dataIndex: 'opening_date',
    key: 'instrument',
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
      render: (value) => <a>{moment(value).format("YYYY-MM-DD")}</a>,

  },
  {
    title: 'Segment',
    dataIndex: 'segment',
    key: 'segment',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
  {
    title: 'Series',
    dataIndex: 'series',
    key: 'series',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
  {
    title: 'Trade Type',
    dataIndex: 'trade_type',
    key: 'trade_type',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => <a>{value == "buy" ? <Tag color="green">BUY</Tag> : <Tag color="red">SELL</Tag>}</a>,
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
  {
    title: 'Auction',
    dataIndex: 'auction',
    key: 'auction',
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => <a>{value ? "True" : "False"}</a>,
  },
  {
    title: 'Buy Value',
    dataIndex: 'buy_value',
    key: 'buy_value',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
   // render: (value) => <span>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</span>,
    render: (value) => {
  const num = typeof value === 'object' && '$numberDecimal' in value
    ? Number(value['$numberDecimal'])
    : Number(value);
  return <span>₹ {isNaN(num) ? "--" : num.toFixed(2)}</span>;
}

  },
  {
    title: 'Sell Value',
    dataIndex: 'sell_value',
    key: 'sell_value',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
   render: (value) => {
  const num = typeof value === 'object' && '$numberDecimal' in value
    ? Number(value['$numberDecimal'])
    : Number(value);
  return <span>₹ {isNaN(num) ? "--" : num.toFixed(2)}</span>;
}

    // render: (value) => <span>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</span>,
  },
  {
    title: 'opening_price',
    dataIndex: 'opening_price',
    key: 'opening_price',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => {
  const num = typeof value === 'object' && '$numberDecimal' in value
    ? Number(value['$numberDecimal'])
    : Number(value);
  return <span>₹ {isNaN(num) ? "--" : num.toFixed(2)}</span>;
}

    //render: (value) => <span>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</span>,
  },
  {
    title: 'closing_price',
    dataIndex: 'closing_price',
    key: 'closing_price',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
   render: (value) => {
  const num = typeof value === 'object' && '$numberDecimal' in value
    ? Number(value['$numberDecimal'])
    : Number(value);
  return <span>₹ {isNaN(num) ? "--" : num.toFixed(2)}</span>;
}

    // render: (value) => <span>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</span>,
  },
  {
    title: 'Profit',
    dataIndex: 'profit',
    key: 'profit',
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    render: (value) => {
  const num = typeof value === 'object' && '$numberDecimal' in value
    ? Number(value['$numberDecimal'])
    : Number(value);
  return <span>₹ {isNaN(num) ? "--" : num.toFixed(2)}</span>;
}

    //render: (value) => <span>{Number(parseFloat(value['$numberDecimal'])).toFixed(2) > 0 ? (<Tag color='green'>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</Tag>) : (<Tag color='red'>₹ {Number(parseFloat(value['$numberDecimal'])).toFixed(2)}</Tag>)}</span>,
  },
//   {
//     title: 'Exit Date & Time',
//     dataIndex: 'closing_date',
//     key: 'closing_date',
//     onHeaderCell: () => ({
//       style: {
//         whiteSpace: 'nowrap',
//       },
//     }),
//     onCell: () => ({
//       style: {
//         whiteSpace: 'nowrap',
//       },
//     }),
//    render: (value) => {
//   const num = typeof value === 'object' && '$numberDecimal' in value
//     ? Number(value['$numberDecimal'])
//     : Number(value);
//   return <span>₹ {isNaN(num) ? "--" : num.toFixed(2)}</span>;
// }

//     // render: (value) => <a>{moment(value).format("YYYY-MM-DD h:mm A")}</a>,
//   },

{
  title: 'Exit Date & Time',
  dataIndex: 'closing_date',
  key: 'closing_date',
  onHeaderCell: () => ({
    style: {
      whiteSpace: 'nowrap',
    },
  }),
  onCell: () => ({
    style: {
      whiteSpace: 'nowrap',
    },
  }),
  render: (value) => value ? <span>{moment.utc(value).format("YYYY-MM-DD h:mm:ss A")}</span> : "--"
}
,
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <a>Notes </a>
      </Space>
    ),
  },
    {
    title:'Broker_code',
    dataIndex: 'broker_code',
    key: 'broker_code',
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
    
  },
];

const DailyTradeTable = (props) => {
const {data} = props;

  return (
    <> 
    { data.length > 0 ? (

      <Table 
      columns={columns} 
      dataSource={data}  
      size='small'
      rowKey={( record ) => record._id} 
      style={{width: "100%"}} 
      pagination={{position: ["none", "none"]}} 
      tableProps={{ tableLayout: "fixed"}} 
      scroll={{x: "scroll"}} 
      headerColor/>
    ):(
    <>
      <Empty />
    </>
    )} 
    </>
);

}
export default DailyTradeTable;